import { useEffect, useRef } from "react";

import { queryClient } from "@/lib/queryClient";
import { dropCachedDataExceptUser, identityOf, shouldDropCachedData, type CachedIdentity } from "@/lib/session-cache";

export function useDropCacheOnIdentityChange(user: { id: number; role: string } | null | undefined): void {
  const lastIdentity = useRef<CachedIdentity>(undefined);

  useEffect(() => {
    const next = identityOf(user);
    if (shouldDropCachedData(lastIdentity.current, next)) dropCachedDataExceptUser(queryClient);
    if (next !== undefined) lastIdentity.current = next;
  }, [user]);
}
